module.exports = __webpack_public_path__ + "img/animated.2f42acd3.gif";